<div class="app-search">
  <svg class="app-search-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
    stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
    <circle cx="11" cy="11" r="8"></circle>
    <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
  </svg>
  <input
    class="app-search-field"
    type="text"
    [value]="value"
    [placeholder]="placeholder"
    autocomplete="off"
    (input)="onInput($any($event.target).value)"
  />
  <button type="button" class="app-search-clear" [class.app-search-clear--hidden]="!value" (click)="onClear()"
    aria-label="Clear search">
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
      <line x1="18" y1="6" x2="6" y2="18"></line>
      <line x1="6" y1="6" x2="18" y2="18"></line>
    </svg>
  </button>
</div>
